import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';

import TransactionStatus from './TransactionStatus'
import DatePriceProgress from './DatePriceProgress'
import Price from "./Price";
import { Web3StatusContext } from "../contexts/Web3StatusContext";
import DisplayedWeiData from './DisplayedWeiData'
import { Trans } from 'react-i18next';
import DateComponent from "./DateComponent";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class PaymentForm extends React.Component {
  static contextType = Web3StatusContext;
  lastBlock = 0;

  state = {
    goalReachedDataKey: null,
    tokensRaisedDataKey: null,
    capReachedDataKey: null,
    hardCapDataKey: null,
    nonWhitelistTimeDataKey: null,
    getIndividualMinCapDataKey: null,
    isWhitelistedDataKey: null,
    getIndividualCapDataKey: null,
    nonWhiteListPercentageDataKey: null,
    currentRate: null,
    isOpen: null,
    transactionError: null,
    transactionRes: null,
    inputBNB: 0,
    stackId: -1,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
    
    var isWhitelistedDataKey = null;
    const goalReachedDataKey = contract.methods["goalReached"].cacheCall();
    const tokensRaisedDataKey = contract.methods["totalTokenRaised"].cacheCall();
    const capReachedDataKey = contract.methods["capReached"].cacheCall();
    const hardCapDataKey = contract.methods["cap"].cacheCall();
    const nonWhitelistTimeDataKey = contract.methods["getTime"].cacheCall(2);
    const getIndividualMinCapDataKey = contract.methods["getIndividualMinCap"].cacheCall();
    const getIndividualCapDataKey = contract.methods["getIndividualCap"].cacheCall(0);
    const nonWhiteListPercentageDataKey = contract.methods["nonWhiteListPercentage"].cacheCall();

    if(this.context.activeAccount != null)
      isWhitelistedDataKey = contract.methods["isWhitelisted"].cacheCall(this.context.activeAccount);
    
    this.setState({ goalReachedDataKey, tokensRaisedDataKey,
        capReachedDataKey, hardCapDataKey,
        nonWhitelistTimeDataKey, getIndividualMinCapDataKey,
        isWhitelistedDataKey, getIndividualCapDataKey,
        nonWhiteListPercentageDataKey});
        
console.log('difference');
        contract.methods.isOpen().call().then(function(result) {
          this.setState({isOpen: Number(result)});
        }.bind(this));
    
        contract.methods.getCurrentRate().call().then(function(result) {
          this.setState({currentRate: Number(result)});
        }.bind(this));
  }

  componentDidUpdate() {
    if(this.lastBlock == this.context.blockNumber)
      return;

    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
    
    contract.methods.isOpen().call().then(function(result) {
      this.setState({isOpen: Number(result)});
    }.bind(this));

    contract.methods.getCurrentRate().call().then(function(result) {
      this.setState({currentRate: Number(result)});
    }.bind(this));

    this.lastBlock = this.context.blockNumber;
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    const { GAMEFORESTSale } = this.props.drizzle.contracts;

    const stackId = GAMEFORESTSale.methods.buyTokens.cacheSend(
          this.context.activeAccount,
          {value:
            this.context.web3.utils.toWei(this.state.inputBNB.toString(), "ether")});
    this.setState({stackId: stackId});
  }

  isNumber(n) {
    return !isNaN(n) && isFinite(n);
  }

  myChangeHandler = (event) => {
    let { value, min, max } = event.target;

    var bnbAmount = parseFloat(value);
    if (!this.isNumber(bnbAmount)) {
      bnbAmount = this.state.inputBNB;
    }
    
    this.setState({inputBNB: bnbAmount});
  }
  

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var goalReachedContract = GAMEFORESTSale["goalReached"][this.state.goalReachedDataKey];
    var totalTokenRaisedContract = GAMEFORESTSale["totalTokenRaised"][this.state.tokensRaisedDataKey];
    var capReachedContract = GAMEFORESTSale["capReached"][this.state.capReachedDataKey];
    var capContract = GAMEFORESTSale["cap"][this.state.hardCapDataKey];
    var nonWhitelistTimeContract = GAMEFORESTSale["getTime"][this.state.nonWhitelistTimeDataKey];
    var getIndividualMinCapContract = GAMEFORESTSale["getIndividualMinCap"][this.state.getIndividualMinCapDataKey];
    var nonWhiteListPercentageContract = GAMEFORESTSale["nonWhiteListPercentage"][this.state.nonWhiteListPercentageDataKey];

    var isWhitelistedContract = undefined;
    if(this.state.isWhitelistedDataKey != null)
      isWhitelistedContract = GAMEFORESTSale["isWhitelisted"][this.state.isWhitelistedDataKey];

    var getIndividualCapContract = undefined;
    if(this.state.getIndividualCapDataKey != null)
      getIndividualCapContract = GAMEFORESTSale["getIndividualCap"][this.state.getIndividualCapDataKey];

    var prograssBarVariant = {};

    if(goalReachedContract === undefined ||
      totalTokenRaisedContract === undefined ||
      capContract === undefined ||
      capReachedContract == undefined ||
      nonWhitelistTimeContract == undefined ||
      getIndividualMinCapContract == undefined ||
      nonWhiteListPercentageContract === undefined ||
      this.state.isOpen == null ||
      this.state.currentRate == null ||
      ((isWhitelistedContract == undefined || getIndividualCapContract == undefined) && this.context.activeAccount != null)) {

        console.log(goalReachedContract);
        console.log(totalTokenRaisedContract);
        console.log(capContract);
        console.log(capReachedContract);
        console.log(nonWhitelistTimeContract);
        console.log(getIndividualMinCapContract);
        console.log(nonWhiteListPercentageContract);
        console.log(this.state.isOpen);
        console.log(this.state.currentRate);
        console.log(isWhitelistedContract);
        console.log(getIndividualCapContract);
        console.log(this.context.activeAccount);

      return <div>Loading...</div>;
    }
    
    var nonWhitelistTime = parseInt(nonWhitelistTimeContract.value);
    const nowUnix = Math.floor(Date.now() / 1000);

    var nonWhitelistTimeEntered = nowUnix >= nonWhitelistTime;

    const individualMinCap = getIndividualMinCapContract.value;
    var individualMinCapEth = this.context.web3.utils.fromWei(individualMinCap, "ether");

    var softcapMet = "";
    if(goalReachedContract.value) {
      prograssBarVariant['variant'] = 'success';
      //softcapMet = <div style={{ color: 'green' }}><Trans>payment_form.softcap_met</Trans></div>;
    }
    
    var buyingHowMuchTokens = this.state.currentRate * this.state.inputBNB;
    if(this.context.activeAccount != null && !isWhitelistedContract.value) {
      buyingHowMuchTokens = nonWhiteListPercentageContract.value * buyingHowMuchTokens / 100.0;
    }
    
    var totalTokenRaisedContractDisplay = this.context.web3.utils.fromWei(totalTokenRaisedContract.value, "ether");
    var capDisplay = this.context.web3.utils.fromWei(capContract.value, "ether");
    var remaining = parseFloat(capDisplay) - parseFloat(totalTokenRaisedContractDisplay);

    var bnbRaised = Number(totalTokenRaisedContractDisplay) / this.state.currentRate;
    var hardcapBNB = Number(capDisplay) / this.state.currentRate;

    var buttonCaption = this.context.i18n.t('payment_form.button_caption');

    var date_price_progress = (<div style={{display: "flex",alignItems:'center'}} className="justify-content-center">
          <div style={{width:'50%'}}>
            <DatePriceProgress
              drizzle={this.props.drizzle}
              drizzleState={this.props.drizzleState}
              firstDateName={1}
              lastDateName={3}
              firstRateName="initialRate"
              lastRateName="finalRate"
              currentRateName="getCurrentRate">

            </DatePriceProgress>
          </div>
          </div>);
    date_price_progress = '';//remove this line for increasing prices

    var form = 
      <span>
        <DatePriceProgress
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          firstDateName={1}
          lastDateName={3}
          firstRateName="initialRate"
          lastRateName="finalRate"
          currentRateName="getCurrentRate"
          textOnly="true">
        </DatePriceProgress>
      </span>;
    if(capReachedContract.value) {
      form = <span><Trans>payment_form.hardcap_met</Trans></span>;
    }
    else if(this.context.activeAccount == null) {
      form = <span><Trans>payment_form.connect_account</Trans><br/>
              <button onClick={this.context.connect}>
              <Trans>connect_account</Trans>
              </button>
            </span>;
    }
    else {
      const individualCap = getIndividualCapContract.value;
      var individualCapEth = this.context.web3.utils.fromWei(individualCap, "ether");
      if(this.state.isOpen) {
        if(!nonWhitelistTimeEntered && !isWhitelistedContract.value) {
          form = (
          <div>
            <Trans>payment_form.not_whitelisted1</Trans>
            <DateComponent drizzle={this.props.drizzle}
              drizzleState={this.props.drizzleState}
              dateName="getTime"
              getterParameter={2}>
            </DateComponent>
            <Trans>payment_form.not_whitelisted2</Trans>
          </div>
          );
        }
        else {
          individualMinCapEth = Number(individualMinCapEth);
          individualCapEth = Number(individualCapEth);
          var tokensInRange = buyingHowMuchTokens <= remaining;
          var inputValueInRange = this.state.inputBNB >= individualMinCapEth &&
                                    this.state.inputBNB <= individualCapEth;
          var submitButtonEnabled = inputValueInRange && tokensInRange;
          var warningMessage = '';
          var warningMessage2 = '';
          if(!inputValueInRange) {
            warningMessage = (
              <div style={{color:'red'}}>
                <Trans>payment_form.warning_message_1</Trans>{individualMinCapEth}
                <Trans>payment_form.warning_message_2</Trans>
                {individualCapEth}
              </div>
            );
          }
          if(!tokensInRange) {
            warningMessage2 = (
              <div style={{color:'red'}}>
                <Trans>payment_form.warning_message2_1</Trans>{remaining}<Trans>payment_form.warning_message2_2</Trans>
              </div>
            );
          }
          var increase_text = (<span style={{ color: 'red' }}>
                <Trans>payment_form.increasing_price</Trans>
                </span>);
          increase_text = '';
          form = (
            <form onSubmit={this.mySubmitHandler}>
              <Trans>payment_form.instructions_1</Trans>{individualCapEth}<Trans>payment_form.instructions_2</Trans><br/>
              <input
                type="number"
                step={0.00000001}
                min={individualMinCapEth}
                max={individualCapEth}
                value={this.state.inputBNB}
                onChange={this.myChangeHandler}
              />
              <br/>
              <br/>
              

              {date_price_progress}

              {increase_text}
              <br/>
              <Trans>payment_form.get_tokens_1</Trans><span style={{  }}>{buyingHowMuchTokens}</span><Trans>payment_form.get_tokens_2</Trans>
              <br/>
              <Trans>payment_form.held_vesting_1</Trans>
              <DisplayedWeiData
                drizzle={this.props.drizzle}
                drizzleState={this.props.drizzleState}
                contract="GAMEFORESTSale"
                method="balanceOf"
                methodArgs={[this.context.activeAccount]}
              />{" "}
              <ContractData
                drizzle={this.props.drizzle}
                drizzleState={this.props.drizzleState}
                contract="GAMEFOREST"
                method="symbol"
                hideIndicator
              />
              <Trans>payment_form.held_vesting_2</Trans>
              <br/>
              {warningMessage}
              {warningMessage2}
              <input
                type='submit'
                disabled={!submitButtonEnabled}
                value={buttonCaption}
              />
            </form>
          );
        }
      }
    }

    

    return (
      <div><Trans>payment_form.current_price</Trans><br/>
        <ContractData
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          contract="GAMEFORESTSale"
          method="getCurrentRate"
        />{" "}
        <ContractData
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          contract="GAMEFOREST"
          method="symbol"
          hideIndicator
        />{"/BNB"}
        <br/>
        
        <Price
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          priceName="getCurrentRate">
        </Price>
        
        <br/>
        {bnbRaised}/{hardcapBNB}{" BNB"}
        <br/>
        {softcapMet}
        <ProgressBar animated max={capContract.value} now={totalTokenRaisedContract.value} {...prograssBarVariant}/>
        <br/>
        {statusMsg}
        <br/>
        {form}

        

      </div>
      
    );
  }
};

export default PaymentForm;